import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  Optional,
} from "@angular/core";
import {
  PershingCoreModule,
  PershingTranslationService,
} from "@pershing/pershing-core";
import {
  PershingCommonModule,
  PershingModalService,
} from "@pershing/pershing-common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { BalancesSummaryComponent } from "./components/balances-summary/balances-summary.component";
import { BalancesService } from "./services/balances.services";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatOptionModule } from "@angular/material/core";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatCardModule } from "@angular/material/card";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDividerModule } from "@angular/material/divider";
import { MatMenuModule } from "@angular/material/menu";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatTableModule } from "@angular/material/table";
import { NxiBalancesGridHeaderComponent } from "./components/supporting/nxi-balances-grid-header.component";
import { CellRenderKeyComponent } from "./components/supporting/cellRender-key.component";
import { CellRenderValueComponent } from "./components/supporting/cellRender-value.component";
import { BalancesDetailsChildrowsComponent } from "./components/balances-details/balances-details-childrows.component";
import { AgGridModule } from "@ag-grid-community/angular";
import { CurrencyBalancesGridComponent } from "./components/currency-balances/currency-balances-grid.component";
import { CellRenderValueCComponent } from "./components/supporting/cellRender-valuec.component";
import { TaxReclaimReceivablesComponent } from "./components/tax-reclaim-receivables/tax-reclaim-receivables.component";
import { BalancesDetailsContainerComponent } from "./components/balances-details/balances-details-container.component";
import { BalancesDetailsBrokerageGridComponent } from "./components/balances-details/balances-details-brokerage-grid.component";
import { BalancesDetailsCustodianGridComponent } from "./components/balances-details/balances-details-custodian-grid.component";
import { BalancesDetailsCombinedCellRenderComponent } from "./components/balances-details/balances-details-combined-cellRender.component";
import { BalancesDetailsCombinedGridComponent } from "./components/balances-details/balances-details-combined-grid.component";
import { CurrencyBalancesComponent } from "./components/currency-balances/currency-balances.component";
import { CurrencyBalancesCellrenderComponent } from "./components/currency-balances/currency-balances-cellrender.component";
import { CellRenderValueMobileComponent } from "./components/supporting/cellRender-value-mobile.component";
import { CurrencyBalancesMobileGridComponent } from "./components/currency-balances/currency-balances-mobile-grid.component";
import { MobileViewSwitchComponent } from "./components/mobile-view-link/mobile-view-link.component";
import { BalanceDetailsContainerComponent } from "./components/balances-details/balance-details-container.component";
import { MortgagesComponent } from "./components/balances-details/mortgages.component";
import { LoansComponent } from "./components/balances-details/loans.component";
import { BalancesDisclaimerComponent } from "./components/balances-disclaimer/balances-disclaimer.component";
import { GridExportService, NxiCommonModule, NxiCarouselComponent } from "@pershing/nxi-common";
import { LicenseManager } from "@ag-grid-enterprise/all-modules";
import { QuoteToggleModule } from "@pershing/nxi-ng-quotetoggle";
import { BalancesQuoteDownloadWrapperComponent } from "./components/quote-download-wrapper/quote-download-wrapper.component";
import { BalancesCommonUtils } from "./utils/balances-utils";
import { LoanAdvanceSummaryComponent } from "./components/balances-details/loanadvance-summary.component";
import { LoanAdvanceComponent } from "./components/balances-details/loanadvance.component";
import { ForeignExchangeComponent,  RateBoardModule} from "@pershing/nxi-ng-rateboard";
import { OutStandAmountComponent } from "./components/balances-details/outstandamount.component";
import { OverviewSummaryComponent } from "./components/overview-summary/overview-summary.component";
import { UnRealizedGainLossService } from "./services/unrealized.gainloss.service";
import { ChartModule } from 'angular-highcharts';
import { CurrencyPipe, DecimalPipe } from '@angular/common';

export const COMPONENTS = [
  BalancesSummaryComponent,
  NxiBalancesGridHeaderComponent,
  CellRenderKeyComponent,
  CellRenderValueComponent,
  BalancesDetailsChildrowsComponent,
  CurrencyBalancesGridComponent,
  CellRenderValueCComponent,
  TaxReclaimReceivablesComponent,
  BalancesDetailsContainerComponent,
  BalancesDetailsBrokerageGridComponent,
  BalancesDetailsCustodianGridComponent,
  BalancesDetailsCombinedCellRenderComponent,
  BalancesDetailsCombinedGridComponent,
  CurrencyBalancesComponent,
  CurrencyBalancesCellrenderComponent,
  CellRenderValueMobileComponent,
  CurrencyBalancesMobileGridComponent,
  MobileViewSwitchComponent,
  BalanceDetailsContainerComponent,
  MortgagesComponent,
  LoansComponent,
  BalancesDisclaimerComponent,
  BalancesQuoteDownloadWrapperComponent,
  LoanAdvanceSummaryComponent,
  LoanAdvanceComponent,
  OutStandAmountComponent,
  OverviewSummaryComponent,
];

export const PROVIDERS = [
  DatePipe,
  PershingTranslationService,
  BalancesService,
  PershingModalService,
  GridExportService,
  BalancesCommonUtils,
  UnRealizedGainLossService,
  CurrencyPipe,
  DecimalPipe

];

@NgModule({
  imports: [
    // This will be moved to app specific
    // common module and appsepcific common module will be
    // imported here
    PershingCoreModule,
    PershingCommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressBarModule,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    MatMenuModule,
    MatInputModule,
    MatButtonModule,
    MatGridListModule,
    AgGridModule.withComponents([
      NxiBalancesGridHeaderComponent,
      BalancesDetailsChildrowsComponent,
      CellRenderKeyComponent,
      CellRenderValueComponent,
    ]),    
    MatButtonToggleModule,
    MatTableModule,
    NxiCommonModule,
    QuoteToggleModule,
    ChartModule,
    RateBoardModule
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  entryComponents: [...COMPONENTS, NxiCarouselComponent, ForeignExchangeComponent],
  providers: [...PROVIDERS],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NxiBalancesModule {
  constructor(@Inject("AppSettings") @Optional() appSettings: any) {
    LicenseManager.setLicenseKey(appSettings.agGridEnterpriseKey);
  }
}
